import * as React from "react";
import { LocalizationService } from "../../../services/LocalizationService";
import { ProgressListItem } from "./progressListItem/ProgressListItem";
import { IProgressViewStatus } from "../../../interfaces/IProgressViewStatus";
import { IAButton } from "../../button/Button";
const ProgressListContent = require('./progressList.json');

export interface IProgressListProps {
  currentStep: number;
  stepsCompletedWithIssues: number[];
  status: IProgressViewStatus;
  onRetry?: () => void;
}

export interface IProgressListState {
  currentStep: number;
  stepsCompletedWithIssues: number[];
}

export class ProgressList extends React.Component<IProgressListProps, IProgressListState> {
  constructor(props: IProgressListProps) {
    super(props);
    this.state = {
      currentStep: props.currentStep,
      stepsCompletedWithIssues: props.stepsCompletedWithIssues
    }
  }

  public componentDidUpdate(prevProps): void {
    if (prevProps.currentStep !== this.props.currentStep) {
      this.setState({
        currentStep: this.props.currentStep
      });
    }
    if (prevProps.stepsCompletedWithIssues.length !== this.props.stepsCompletedWithIssues.length) {
      this.setState({
        stepsCompletedWithIssues: this.props.stepsCompletedWithIssues
      });
    }
  }

  public render(): JSX.Element {
    return (
      <div>
        {ProgressListContent.map((item) => (
          <ProgressListItem
            key={`ProgressViewListItem_${item.id}`}
            label={new LocalizationService().strings[`ProgressViewListItem_${item.id}`]}
            step={item.step}
            isCompleted={this.props.status === IProgressViewStatus.Completed ? true : this.state.currentStep > item.step ? true : false}
            isRunning={this.state.currentStep == item.step}
            isFailed={this.props.status === IProgressViewStatus.Failed ? this.state.currentStep == item.step : false}
            requiresAttention={this.state.currentStep > item.step && this.state.stepsCompletedWithIssues.indexOf(item.step) !== -1}
          />
        ))}
        <div style={{marginTop: 40}}>
          <IAButton
            label={new LocalizationService().strings.ProgressView_RetryButton}
            styleLabel={{ padding: "0 6px", marginBottom: 30 }}
            style={{
              display: this.props.status !== IProgressViewStatus.Failed ? "none" : "block"
            }}
            buttonColor="#eee"
            arialable="Retry"
            onClick={async () => this.props.onRetry()}
          />
        </div>
      </div>
    );
  }
}